

import React, { Suspense } from "react";

const Area = React.lazy(() =>
  import("@ant-design/plots").then(module => ({ default: module.Area }))
);

const AreaChart = ({ config }) => {
  return (
    <Suspense fallback={<div>Loading chart...</div>}>
      <Area {...config} />
    </Suspense>
  );
};

export default AreaChart;

